

























import { computed, defineComponent, Ref } from '@vue/composition-api';
import store                              from '@/store';

const Template: object = defineComponent({
  props: {
    active: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/map.svg'),
    },
    iconhc: {
      type: String,
      // eslint-disable-next-line global-require
      default: require('@/assets/img/top_icons/map.svg'),
    },
    text: {
      type: String,
      // eslint-disable-next-line global-require
      default: '<placeholder>',
    },
    titleTooltip: {
      type: String,
      // eslint-disable-next-line global-require
      default: '<placeholder>',
    },
  },
  name: 'MainIcon',
  setup() {
    const getContrastActive: Ref<boolean> = computed((): boolean => store.getters.getContrastActive);

    return {
      getContrastActive,
    };
  },
});
export default Template;
